import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ConstantsKey } from "app/shared/constant/constants-keys";

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {


  public tempPersonaProfileObj;
  constructor(public router: Router) {}

  ngOnInit(): void {
    this.logout();
  }

  logout() {

      this.tempPersonaProfileObj = localStorage.getItem(ConstantsKey.USER_PERSONA_PROFILE);
      localStorage.clear();
      sessionStorage.clear();

      if(this.tempPersonaProfileObj) {
        localStorage.setItem(ConstantsKey.USER_PERSONA_PROFILE, this.tempPersonaProfileObj);
      }

      if(window.location.origin == "https://consumer.wsfxglobalpay.com" || window.location.origin == "https://globalpay.wsfx.in") {
        window.location.replace("https://wsfxglobalpay.com/");
      } else {
        window.location.replace("https://uat.wsfxglobalpay.com/");        
      }


    /* this.router.navigate(['/login']).then(() => {
      this.tempPersonaProfileObj = localStorage.getItem(ConstantsKey.USER_PERSONA_PROFILE);
      localStorage.clear();
      sessionStorage.clear();

      if(this.tempPersonaProfileObj) {
        localStorage.setItem(ConstantsKey.USER_PERSONA_PROFILE, this.tempPersonaProfileObj);
      }
      
      window.location.reload();
    }); */
  }
}
